// extracted by mini-css-extract-plugin
export default {"section":"search_bar_section-module__section--CsYjl","container":"search_bar_section-module__container--3DtRN","btn":"search_bar_section-module__btn--2aSLn"};